module.exports = __webpack_public_path__ + "965b10d605c1dab6cde2f9d689568d84.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-night-mountains.png
// module id = 1010
// module chunks = 0